'use client';

import { useTranslations } from 'next-intl';
import type { ProfileListEditorLabels } from './ProfileListEditor';

export type BusinessProfileStringList = 'locations' | 'brandsServicesProducts';

export const useProfileListEditorLabels = (
  list: BusinessProfileStringList,
): ProfileListEditorLabels & { title: string; tooltip: string } => {
  const t = useTranslations('designSystem.networkSettings.businessProfile');

  return {
    title: t(`${list}.sectionTitle`),
    tooltip: t(`${list}.tooltip`),
    emptyState: t(`${list}.emptyState`),
    add: t(`${list}.add`),
    addTitle: t(`${list}.addTitle`),
    editTitle: t(`${list}.editTitle`),
    fieldLabel: t(`${list}.label`),
    fieldPlaceholder: t(`${list}.placeholder`),
    validationRequired: t('validation.required'),
    validationDuplicate: t('validation.duplicate'),
  };
};
